import Service from '@/service/index.js';
import TransactionProService from '../../transaction-pro-service';
import { mapGetters } from 'vuex';
import { successMessage } from '@/utils/message.js';
import SigninDialog from '@/views/signin/signin-dialog/signin-dialog.vue';
import Bus from '../../bus.js';
// import QRCode from 'qrcodejs2';

export default {
  components: {
    SigninDialog
  },
  props: {
    slides: {
      type: Array,
      default: []
    },
    getProjectvideolist: {
      type: Array,
      default: () => []
    },
    projectInfo: {
      type: Object,
      default: {}
    },
    type: {
    },
    transfereeInfo: {
      type: Object,
      default: {}
    }
    // status: {
    //   type: String,
    //   default: []
    // }
  },
  data () {
    return {
      projectStatus: [],
      projectTypeArr: [],
      bidTypeArr: [],
      isShowsignUpBtn: false, // 报名按钮的展示
      dialogVisible: false,
      qrcodeShow: false,
      tabPosition: '1'
    };
  },
  computed: {
    projectTypeText () {
      if (!this.projectTypeArr.length) { return ''; }
      const obj = this.projectTypeArr.find(item => item.code === String(this.projectInfo && this.projectInfo.projectType));
      if (obj) {
        const subObj = obj.list && obj.list.find(item => item.code === String(this.projectInfo && this.projectInfo.projectSubType));
        if (subObj) {
          return obj.value + ' · ' + subObj.value;
        } else {
          return obj.value;
        }
      } else {
        return '';
      }
    },
    noticeEndTimeHoursAdd1 () {
      const str = this.projectInfo && this.projectInfo.noticeEndTime;
      if (str) {
        const timeStr = new String(str).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
        return this.formatDate(new Date(new Date(timeStr).getTime() + 3600000 * 16 + 8 * 60 * 60 * 1000), 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    projectCode () {
      if (this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
        return `${this.projectInfo.projectType}-${this.projectInfo.projectSubType}`;
      }
    },
    ...mapGetters([
      'isSignin',
      'assetsBidInfos',
      'userInfo'
    ])
  },
  created () {
    const arr = [
      ['projectStatus', 'PROJECT_STATUS'], ['projectTypeArr', 'PROJECT_TYPE'], ['bidTypeArr', 'BIDDING_METHOD']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
  },
  mounted () {
    Bus.$on('msg', () => {
      this.checkCurrentUserSign();
    });
    // this.creatQrCode();
  },
  watch: {
    projectInfo (newValue) {
      if (newValue) {
        if (this.isSignin) {
          this.checkCurrentUserSign();
        } else {
          this.checkCurrentUserSignForUnlogin();
        }
        if (Number(newValue.signStatus) === 0) {
          // 70 已成交的状态
          if (70 <= newValue.status && newValue.status <= 90) {
            newValue.status = 70;
          } else if (newValue.status === 92 || newValue.status === 93 || newValue.status === 94 || newValue.status === 95) {
            newValue.status = 95; // 95 已结束的状态
          }
        } else {
          newValue.status = 50; // 50 报名中
        }
      }
    },
    slides (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.galleryThumbsLunbo();
          this.galleryTopLunbo();
        });
      }
    }
  },
  methods: {
    inputchange () {
      if (this.tabPosition === '1') {
        if (this.getProjectvideolist.length > 0) {
          this.getProjectvideolist.forEach((item, index) => {
            document.getElementById('my_player' + index).pause();
          });
        }
      }
      // console.log(this.tabPosition);
    },
    formatDate (date, fmt) {
      let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      for (let k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
      return fmt;
    },
    // 划过二维码展示
    hover () {
      this.qrcodeShow = true;
    },
    hoverdown () {
      this.qrcodeShow = false;
    },
    // 生成二维码
    creatQrCode () {
      const url = window.location.host;
      let urlCode = '';
      if (url.indexOf('stage.portal-tiandong.cacfintech.com') >= 0 || url.indexOf('stage') >= 0) {
        urlCode = 'http://m.jlncjy.cn/#/project/detail?id=' + this.$route.query.id;
      } else if (url.indexOf('test') >= 0) {
        urlCode = 'http://test.m.jlncjy.cacfintech.com/#/project/detail?id=' + this.$route.query.id;
      } else if (url.indexOf('dev') >= 0 || url.indexOf('localhost') >= 0) {
        urlCode = 'http://dev.m.jlncjy.cacfintech.com/#/project/detail?id=' + this.$route.query.id;
      } else {
        urlCode = 'http://m.jlncjy.com/#/project/detail?id=' + this.$route.query.id;
      }
      setTimeout(() => {
        new QRCode(this.$refs.qrCodeUrl, {
          text: urlCode, // 需要转换为二维码的内容
          width: 90,
          height: 90,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      }, 100);
    },
    // 联动轮播
    galleryThumbsLunbo () {
      this.galleryThumbs = new Swiper('.gallery-thumbs', {
        el: '.gallery-thumbs',
        spaceBetween: 15,    // 在slide之间设置距离（单位px）
        slidesPerView: 5,    // 设置slider容器能够同时显示的slides数量
        loop: false,        // 设置为true 则开启loop模式
        freeMode: true,    // 默认为false，普通模式：slide滑动时只滑动一格
        loopedSlides: 5,    // 一般设置大于可视slide个数2个即可
        watchSlidesVisibility: true,   // 开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
        watchSlidesProgress: true,   // 开启这个参数来计算每个slide的progress(进度、进程)
        observer: true,
        observeParents: true
      });
      this.galleryThumbs1 = new Swiper('.gallery-thumbs1', {
        el: '.gallery-thumbs1',
        spaceBetween: 15,    // 在slide之间设置距离（单位px）
        slidesPerView: 5,    // 设置slider容器能够同时显示的slides数量
        loop: false,        // 设置为true 则开启loop模式
        freeMode: true,    // 默认为false，普通模式：slide滑动时只滑动一格
        loopedSlides: 5,    // 一般设置大于可视slide个数2个即可
        watchSlidesVisibility: true,   // 开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
        watchSlidesProgress: true,   // 开启这个参数来计算每个slide的progress(进度、进程)
        observer: true,
        observeParents: true,
        on: {
          click: () => {
            if (this.getProjectvideolist.length > 0) {
              this.getProjectvideolist.forEach((item, index) => {
                document.getElementById('my_player' + index).pause();
              });
            }
          }
        }
      });
    },
    galleryTopLunbo () {
      this.galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5,
        // 左右按钮
        navigation: {
          el: '#el1',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        thumbs: {        // thumbs组件专门用于制作带缩略图的swiper
          swiper: this.galleryThumbs
        },
        observer: true,
        observeParents: true
      });
      // if (this.galleryTop1) return;
      this.galleryTop1 = new Swiper('.gallery-top1', {
        spaceBetween: 10,
        // loop: true,
        loopedSlides: 5,
        // 左右按钮
        navigation: {
          el: '#el2',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        thumbs: {        // thumbs组件专门用于制作带缩略图的swiper
          swiper: this.galleryThumbs1
        },
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: () => {
            if (this.getProjectvideolist.length > 0) {
              this.getProjectvideolist.forEach((item, index) => {
                document.getElementById('my_player' + index).pause();
              });
            }
          }
        }
      });
    },
    changeActiveIndex (index) {
      console.log(index);
      this.$refs.carousel.slideTo(index);
      this.$refs.carousel.update();
    },
    updateCarousel () {
      this.$refs.carousel.update();
    },
    // 弹框展示
    onSignUp () {
      if (this.isSignin) {
        // 村集体不能报名项目
        if (this.userInfo.type === 3) {
          this.$errorMessage('抱歉，农村集体经济组织用户不可参与项目报名。');
          return;
        }
        this.$emit('onSignUp');
      } else {
        // transferType 判断是整体报名还是拆分报名
        // this.$router.push('/signin');
        this.dialogVisible = true;
      }
      if (this.assetsBidInfos.length <= 0) {
        successMessage('请选择标的');
        return;
      }
    },
    // 按钮颜色展示 项目状态
    getProjectStatusStyle (statused) {
      let status = Number(statused);
      if (status === 43) {
        return 'background: #F7B500';
      } else if (status === 50) {
        return 'background: #00B58D';
      } else if (status === 51) {
        return 'background: #0DCE03';
      } else if (status === 60) {
        return 'background: #FA5741';
      } else if ([70, 95, 97].includes(status)) {
        return 'background: #383838';
      } else if (status === 42) {
        return 'background: #F7B500';
      }
    },
    checkCurrent () {
      this.dialogVisible = false;
      Bus.$emit('msg');
      this.checkCurrentUserSign();
    },
    checkCurrentUserSign () {
      TransactionProService.checkCurrentUserSign(this.$route.query.id).then(res => {
        if (res && res.code === '0') {
          if (res.data && res.data.signFlag) {
            this.isShowsignUpBtn = true;
            return;
          }
          this.isShowsignUpBtn = false;
        }
      });
    },
    checkCurrentUserSignForUnlogin () {
      TransactionProService.checkCurrentUserSignForUnlogin(this.$route.query.id).then(res => {
        if (res && res.code === '0') {
          if (res.data && res.data.signFlag) {
            this.isShowsignUpBtn = true;
            return;
          }
          this.isShowsignUpBtn = false;
        }
      });
    },
    isShowBtn (status) {
      const showBtnArr = [10, 31, 81];
      if (showBtnArr.includes(status)) {
        return true;
      } else {
        return false;
      }
    },
    btnAction () {
      if (this.projectInfo && (this.projectInfo.status === 10)) {
        this.$router.push('/publish-project/publisher-info?id=' + (this.projectInfo && this.projectInfo.projectId));
      }
    }
  }
};
